/**
 * Stable CSS class names for E2E — MP config V2.
 */
export const MPCV2 = {
    page: 'mp-config-v2-page',
    titleSection: 'mp-config-v2-page__title-section',
    pageTitle: 'mp-config-v2-page__title',
    cacheToolbarSection: 'mp-config-v2-page__cache-toolbar-section',
    inputButtonClearMobilePanelCache: 'mp-config-v2-page-input--button-clear-mobile-panel-cache',
    actionsSection: 'mp-config-v2-page__actions-section',
    inputButtonAddConfig: 'mp-config-v2-page-input--button-add-config',
    filterSection: 'mp-config-v2-page__filter-section',
    inputTextSearchKey: 'mp-config-v2-page-input--text-search-key',
    gridSection: 'mp-config-v2-page__grid-section',
    gridWrap: 'mp-config-v2-page__grid-wrap',

    datagridEditCell: 'mp-config-v2-datagrid-actions-cell-edit',
    inputButtonRowEdit: 'mp-config-v2-datagrid-input--button-row-edit',
    datagridDeleteCell: 'mp-config-v2-datagrid-actions-cell-delete',
    inputButtonRowDelete: 'mp-config-v2-datagrid-input--button-row-delete',
} as const;

export const mpcv2Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
